// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const FamiliesLivingPure = createIcon(`
<svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="120" height="120"
	 viewBox="0 0 120 120" style="enable-background:new 0 0 120 120;" xml:space="preserve">
<style type="text/css">
	.families-living0{fill:none;stroke:#FF4114;stroke-width:2.6588;stroke-miterlimit:10;}
	.families-living1{fill:none;stroke:#0A055F;stroke-width:2.6588;stroke-miterlimit:10;}
</style>
<g>
	<path class="families-living0" d="M49.1,50.8c0,7.4-6,13.4-13.5,13.4s-13.5-6-13.5-13.4c0-7.5,6-13.5,13.5-13.5S49.1,43.3,49.1,50.8z"/>
	<path class="families-living0" d="M48.8,72.3c-0.6-0.2-1.2-0.2-1.8-0.2H24.2c-4.1,0-7.5,3.4-7.5,7.4v18.4"/>
	<path class="families-living0" d="M91.4,34.1c0,7.5-6,13.5-13.5,13.5c-7.5,0-13.5-6-13.5-13.5s6-13.5,13.5-13.5C85.4,20.5,91.4,26.6,91.4,34.1z"
		/>
	<path class="families-living0" d="M99.7,101.7V62.9c0-4.1-3.4-7.4-7.4-7.4H63.5c-4.1,0-7.5,3.4-7.5,7.4v3"/>
	<path class="families-living0" d="M70.3,76.6c0,6.2-5,11.2-11.2,11.2s-11.2-5-11.2-11.2c0-6.2,5-11.2,11.2-11.2S70.3,70.4,70.3,76.6z"/>
	<path class="families-living0" d="M75.9,115.4v-12.3c0-4.1-3.4-7.4-7.4-7.4H49.8c-4.1,0-7.4,3.4-7.4,7.4v11.7"/>
	<path class="families-living1" d="M2.5,60c0,31.8,25.8,57.6,57.6,57.6c30.6,0,55.6-23.8,57.4-54v-7.2c-1.8-30.1-26.9-54-57.4-54
		C28.3,2.4,2.5,28.2,2.5,60"/>
</g>
</svg>
`);

export const FamiliesLivingIcon: React.SFC<{ iconClassName?: string }> = (props: { iconClassName?: string }) => (
  <FamiliesLivingPure className={props.iconClassName} />
);

FamiliesLivingIcon.displayName = 'FamiliesLivingIcon';
